import { TMenuItems } from '../../@types';

export const menuItems = (action: { payload: TMenuItems }) => {
  const { label, isSubmenu = false } = action.payload;
  return {
    event: 'analytics-event',
    event_parameters: {
      event_name: `interaction_${isSubmenu ? 'submenu' : 'menu'}`,
      cd_interaction_detail: `click:${label}`,
    },
  };
};
